import React from 'react';
import { Tag } from 'antd';

// Renders a status pill for the 0/1 `status` field used across models.
export default function StatusTag({ value, activeText = 'Active', inactiveText = 'Inactive' }) {
    const active = value === 1 || value === true;
    return (
        <Tag color={active ? 'success' : 'default'} bordered={false}>
            {active ? activeText : inactiveText}
        </Tag>
    );
}
